{
  "sdk-download-android": "Transferir para Android",
  "sdk-connect": "Associar",
  "sdk-download-ios": "Transferir para iOS",
  "sdk-install": "Instalar",
  "sdk-modal-instruct-1": "1. Abre a aplicação Binance",
  "sdk-modal-instruct-2": "2. Toca em {{icon}} no Ecrã Inicial",
  "sdk-modal-title": "Associa com a Binance",
  "sdk-no-app": "Ainda não tens a aplicação Binance?"
}